import produce from "immer";
import axios from "axios";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";
import strings from "../res/strings";

export const CREATE_COLLECTION_ITEM = "luxuryCollection/CREATE_COLLECTION_ITEM";
export const UPDATE_COLLECTION_ITEM = "luxuryCollection/UPDATE_COLLECTION_ITEM";
export const DELETE_COLLECTION_ITEM = "luxuryCollection/DELETE_COLLECTION_ITEM";
export const RETRIEVE_COLLECTION_ITEMS =
  "luxuryCollection/RETRIEVE_COLLECTION_ITEMS";

const CREATE_COLLECTION_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const UPDATE_COLLECTION_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const DELETE_COLLECTION_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const RETRIEVE_COLLECTION_ITEM_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const initialState = {};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_COLLECTION_ITEM: {
        break;
      }

      case UPDATE_COLLECTION_ITEM: {
        break;
      }

      case DELETE_COLLECTION_ITEM: {
        break;
      }

      case RETRIEVE_COLLECTION_ITEMS: {
        break;
      }

      default: {
        break;
      }
    }
  });

export const createCollectionItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_collection.createCollectionItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_COLLECTION_CREATE_COLLECTION_ITEM,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_COLLECTION_ITEM });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_collection.createCollectionItem",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_COLLECTION_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_collection.createCollectionItem",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateCollectionItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_collection.updateCollectionItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_COLLECTION_UPDATE_COLLECTION_ITEM,
        values
      )
      .then((response) => {
        dispatch({ type: UPDATE_COLLECTION_ITEM });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_collection.updateCollectionItem",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_COLLECTION_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_collection.updateCollectionItem",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteCollectionItem = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_collection.deleteCollectionItem",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_COLLECTION_DELETE_COLLECTION_ITEM,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_COLLECTION_ITEM });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "luxury_collection.deleteCollectionItem",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_COLLECTION_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_collection.deleteCollectionItem",
                  notificationType: "alert",
                }
          )
        );
      });
  };
};

export const retrieveCollectionItems = (
  { values, processingState, succcessState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "luxury_collection.retrieveCollectionItems",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LUXURY_COLLECTION_RETRIEVE_COLLECTION_ITEMS,
        values
      )
      .then((response) => {
        dispatch({ type: RETRIEVE_COLLECTION_ITEMS });
        dispatch(
          setAppSuccess(
            typeof succcessState === "function"
              ? succcessState(response, values)
              : succcessState ?? {
                  context: "luxury_collection.retrieveCollectionItems",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_COLLECTION_ITEM_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "luxury_collection.retrieveCollectionItems",
                }
          )
        );
      });
  };
};
